<template>
  <div>
    <QS-h4-title slot="header" title="基本信息" />
    <column-box :list="list" :source="source" :labelWidth="130"/>
  </div>

</template>
<script>

export default {
  name: 'basicInformation',
  props: ['list', 'source'],
}
</script>

<style>

</style>
